export default function redirectToHome() {
	const top = $.iframe.topWindow();

	if (top && typeof top.doHome === 'function') {
		top.doHome();
	}
}
